// Homepage categories — explicit Flickity init.
// Auto-init on data-flickity isn't always reliable when Flickity is bundled
// through webpack, so we initialize the carousel manually after DOM ready.
var Flickity = require( 'flickity' );

document.addEventListener( 'DOMContentLoaded', function () {
	var el = document.querySelector( '.homepage-categories-carousel' );
	if ( ! el || el.classList.contains( 'flickity-enabled' ) ) {
		return;
	}
	new Flickity( el, {
		cellSelector:    '.category-card',
		cellAlign:       'left',
		contain:         true,
		pageDots:        false,
		prevNextButtons: true,
		wrapAround:      false,
		freeScroll:      true,
		imagesLoaded:    true
	} );
} );
